var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"pt-2 scrollable-tab-content m-2"},[_c('b-col',[_c('metadata-node',{attrs:{"item":_vm.root}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }